import get from 'lodash/get';
import { Author, TeamMember } from 'types';

export default (person: Author | TeamMember | null): string => {
  if (!person) {
    return '';
  }

  const honorifics = get(person, 'honorifics', '');

  if (honorifics) {
    return `${person.firstName} ${person.lastName}, ${honorifics}`;
  }

  return `${person.firstName} ${person.lastName}`;
};
